import { render, staticRenderFns } from "./UcContractRevisionDropdown.yaml?vue&type=template&id=c298bae8&component"
import script from "./UcContractRevisionDropdown.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractRevisionDropdown.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports